import { MenuItem } from 'vue-graphql-models';

export default [

  // new MenuItem({
  //   id: 'assetInformation',
  //   title: 'Information',
  //   subtitle: 'Additional details about this screen',
  //   customIcon: true,
  //   icon: 'dhc-info',
  // }),
  new MenuItem({
    id: 'createNewAsset',
    title: 'Create New Asset',
    subtitle: 'Add New Asset',
    route: { name: 'createNewAsset' },
    customIcon: true,
    icon: 'dhc-new',
  }),
  new MenuItem({
    id: 'searchAsset',
    title: 'Search Assets',
    subtitle: 'Filter Assets by keywords',
    icon: 'search',
  }),
  new MenuItem({
    id: 'checkUpdate',
    title: 'Check Updates',
    subtitle: 'Check for New App Version',
    icon: 'update',
  }),
  new MenuItem({
    id: 'assetsMapView',
    title: 'Map View - Coming Soon',
    subtitle: 'Tap to View Asset on Map',
    route: { name: 'assets' },
    customIcon: true,
    icon: 'dhc-maps',
  }),
  new MenuItem({
    id: 'assetsHelp',
    title: 'Help',
    subtitle: 'How to\'s and Contact Info',
    route: { name: 'contactForm' },
    customIcon: true,
    icon: 'dhc-help',
  }),
  new MenuItem({
    id: 'assetEdit',
    title: 'Edit Asset',
    subtitle: 'Edit Asset Details',
    route: { name: 'assetEdit' },
    customIcon: true,
    icon: 'dhc-pencil-s',
  }),
  new MenuItem({
    id: 'assetDelete',
    title: 'Delete Asset',
    subtitle: 'Remove Asset Record',
    customIcon: true,
    icon: 'dhc-trash',
  }),
  new MenuItem({
    id: 'assetClone',
    title: 'Clone Asset',
    subtitle: 'Clone Asset Details',
    route: { name: 'assets' },
    customIcon: true,
    icon: 'dhc-new',
  }),
  new MenuItem({
    id: 'assetAlert',
    title: 'Alerts',
    subtitle: 'Subscribe / unsubscribe from Alerts',
    route: { name: 'assets' },
    customIcon: true,
    icon: 'dhc-alert',
  }),
  new MenuItem({
    id: 'assetChemicalAssign',
    title: 'Assign Chemical',
    subtitle: 'Add Chemical to an Asset',
    route: { name: 'assetChemicalAssign' },
    customIcon: true,
    icon: 'dhc-chemicals',
  }),
  new MenuItem({
    id: 'assetChemicalEdit',
    title: 'Edit Chemical',
    subtitle: 'Edit Chemical assigned to Asset',
    route: { name: 'assetChemicalEdit' },
    customIcon: true,
    icon: 'dhc-pencil-s',
  }),
  new MenuItem({
    id: 'assetChemicalDelete',
    title: 'Delete Chemical',
    subtitle: 'Delete Chemical from Asset',
    customIcon: true,
    icon: 'dhc-trash',
  }),
  new MenuItem({
    id: 'assetMaterialAssign',
    title: 'Assign Material',
    subtitle: 'Add Material to an asset',
    route: { name: 'assetMaterialAssign' },
    customIcon: true,
    icon: 'dhc-materials',
  }),
  new MenuItem({
    id: 'assetMaterialEdit',
    title: 'Edit Material',
    subtitle: 'Edit Material assigned to Asset',
    route: { name: 'assetMaterialEdit' },
    customIcon: true,
    icon: 'dhc-pencil-s',
  }),
  new MenuItem({
    id: 'assetMaterialDelete',
    title: 'Delete Material',
    subtitle: 'Delete Material from Asset',
    customIcon: true,
    icon: 'dhc-trash',
  }),
  new MenuItem({
    id: 'assetCreateJob',
    title: 'Create a New Job',
    subtitle: 'Add a New job',
    route: { name: 'assets' },
    customIcon: true,
    icon: 'dhc-new',
  }),
  new MenuItem({
    id: 'assetNewLabProfile',
    title: 'New Lab Profile',
    subtitle: 'Add a new lab profile record',
    route: { name: 'assets' },
    customIcon: true,
    icon: 'dhc-new',
  }),
  new MenuItem({
    id: 'assetNewLabJob',
    title: 'New Lab Job',
    subtitle: 'Add a new lab job record',
    route: { name: 'assets' },
    customIcon: true,
    icon: 'dhc-new',
  }),
  new MenuItem({
    id: 'assetAddNotes',
    title: 'Add Notes',
    subtitle: 'Add new notes',
    route: { name: 'assets' },
    customIcon: true,
    icon: 'dhc-file-text',
  }),
];
